import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment } from "@mui/material";
import React from "react";
import { useToggle } from "react-use";

import { InputField, InputFieldProps } from "./InputField";

const PasswordInputField: React.VFC<InputFieldProps> = (props) => {
	const [isVisible, toggleVisible] = useToggle(false);

	return (
		<InputField
			{...props}
			type={isVisible ? "text" : "password"}
			endAdornment={
				<InputAdornment position="end">
					<IconButton onClick={toggleVisible} size="small">
						{isVisible ? (
							<VisibilityIcon style={{ fontSize: 20 }} />
						) : (
							<VisibilityOffIcon style={{ fontSize: 20 }} />
						)}
					</IconButton>
				</InputAdornment>
			}
		/>
	);
};

export { PasswordInputField };
